import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryPackageTypesDataGrid } from "src/components/views/erp/warehouse/masterData/packageTypes/DeliveryPackageTypesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/deliveryPackageTypes")({
	staticData: { title: i18n.t("package_types"), legacyViewKey: "deliveryPackageTypesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliveryPackageTypesDataGrid />;
}
